import axios from 'axios'
export default {
    fetchMenu() {
        const kareliasHost = process.env.VUE_APP_KARELIAS_HOST
        return axios.get(kareliasHost + '/wp-json/custom-routes/menus',{
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.data)
    }
}
